import {Component, inject} from '@angular/core';

import {ModalService} from '../../../../services/modal.service';

/**
 * No Matches Modal Component
 * Displays when no matches are found for the user's query
 */
@Component({
  selector: 'app-no-matches-modal',
  standalone: true,
  imports: [],
  templateUrl: './no-matches-modal.component.html',
  styleUrl: './no-matches-modal.component.scss'
})
export class NoMatchesModalComponent {
  private modalService = inject(ModalService);

  // Read-only signals from the modal service
  protected readonly showModal = this.modalService.showNoMatchesModal;
  protected readonly modalData = this.modalService.noMatchesData;

  /**
   * Close the No Matches modal
   */
  closeModal(): void {
    this.modalService.closeNoMatchesModal();
  }
}
